var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39137_433839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26.6667V20H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 0L13.2917 7.54167L23.4167 0H26.6667V2.58333L16.6667 10.0417L26.6667 17.4583V20H23.3333L13.3333 12.5417L3.375 20H0V17.5L9.95833 10.0833L0 2.66667V0H3.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 11.7083L26.6667 18.3333V20L15.375 11.7083H17.6667ZM10 12.5417L10.25 14L2.25 20H0L10 12.5417ZM26.6667 0V0.125L16.2917 7.95833L16.375 6.125L24.5833 0H26.6667ZM0 0L9.95833 7.33333H7.45833L0 1.75V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0417 0V20H16.7083V0H10.0417ZM0 6.66667V13.3333H26.6667V6.66667H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.04167V12.0417H26.6667V8.04167H0ZM11.375 0V20H15.375V0H11.375Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39137_433839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.c3074c071ad623fea2e6a4fe75974eb1.svg";
export { ForwardRef as ReactComponent };